import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Clients, ConnectedIssueDto, PreviewConnectedIssueDto, SubmitConnectedIssueDto } from '@server-models';
import { CoreHttpClientApiBaseService } from '@core/services/http-client-api-base/core-http-client-api-base.service';
import { IIssueService } from '../interfaces/issue-service.interface';

@Injectable({ providedIn: 'root' })
export class SharedIssueConnectedApiService extends CoreHttpClientApiBaseService implements IIssueService {
  getIssuePreview(templateId: number): Observable<PreviewConnectedIssueDto> {
    return this.previewConnected(templateId);
  }

  previewConnected(templateId: number, resourceId?: number): Observable<PreviewConnectedIssueDto> {
    return super.get<PreviewConnectedIssueDto>(`/tech/v2/issue/connected/template/${templateId}/preview`, undefined, {
      params: resourceId === undefined ? {} : { resourceId },
    });
  }

  getIssue(issueId: number): Observable<ConnectedIssueDto> {
    const suffix = this.clientType === Clients.Link ? '/recent' : '';
    return super.get<ConnectedIssueDto>(`/tech/v2/issue/connected/${issueId}${suffix}`);
  }

  sendIssueTemplatePreviewById(templateId: number, issue: SubmitConnectedIssueDto): Observable<void> {
    return super.post<void>(`/tech/v2/issue/connected/template/${templateId}/submitIssue`, undefined, issue);
  }
}
